import { ChartColors, getPricesForAllHorizons, TimeSeriesItem } from '@chart';
import { UseTurboChartReturn } from '@terminal/views/turbo-chart/hooks/use-turbo-chart/useTurboChart';

const IS_CHART_MESSAGE_HEIGHT = '476px';
const IS_LEGACY_VARIANT_HEIGHT = '240px';
const DEFAULT_HEIGHT = '302px';

export const getChartLoadingHeight = (
  isChatMessage: boolean,
  isLegacyVariant: boolean
) => {
  if (isChatMessage) return IS_CHART_MESSAGE_HEIGHT;
  if (isLegacyVariant) return IS_LEGACY_VARIANT_HEIGHT;
  return DEFAULT_HEIGHT;
};

export const getPriceHorizonSettings = ({
  horizonRanges,
  horizon,
  dailyTimeseries,
  colors,
}: {
  horizonRanges: UseTurboChartReturn['horizonRanges'];
  dailyTimeseries: TimeSeriesItem[];
  horizon: UseTurboChartReturn['chartState']['horizon'];
  colors: Pick<ChartColors, 'bars' | 'line'>;
}) => {
  const rangesWithPrice = getPricesForAllHorizons({
    horizonRanges,
    timeseries: dailyTimeseries,
    lastIdx: dailyTimeseries.length - 1,
    colors,
  });
  const foundRange = rangesWithPrice.find(r => r.horizon === horizon);

  return { rangesWithPrice, lineColorToken: foundRange?.lineColorToken };
};
